import MemberLevel from './MemberLevel';

export default (props) => {
  return <MemberLevel {...props} />;
};
